/**
 * Page-local signal that workspace content changed: the invalidation stream
 * raises it for a server content invalidation and after every (re)connect,
 * and open view frames forward it to their guests so view reads refresh the
 * same way the page's own content queries do.
 */
type Listener = () => void;

const listeners = new Set<Listener>();

export function onContentInvalidated(listener: Listener): () => void {
	listeners.add(listener);
	return () => {
		listeners.delete(listener);
	};
}

export function notifyContentInvalidated(): void {
	for (const listener of [...listeners]) {
		try {
			listener();
		} catch {
			// One broken frame must not stop the others refreshing.
		}
	}
}
